import { SAlert, SDrawerOrModal, SLowcodeList, STags } from 'shj-components'
import React, {useRef} from "react";
import {config} from "./config.tsx";
import {get} from "lodash-es";
import {getProductSkuManagementPage} from "@/services/product.ts";
import '@/pages/baseProduct/schemeProductList/index.module.less'
const SKUDetails = (props: any) => {
    const {onClose, record} = props;
    const listRef = useRef<any>();

    const fetchList = ({current, pageSize, query}: any) => {
        return new Promise((resolve, reject) => {
            try {
                getProductSkuManagementPage({
                    params: {pageId: current, pageSize},
                    data: {
                        ...query,
                        productId: record?.productId||"",
                        productCombinationDetailId: record?.id||"",
                        "orderBys": [
                            {
                                "columnName": "id",
                                "asc": false
                            }
                        ],
                        queryShops: true,
                        "searchFlag": true
                    }
                }).then(
                    (res: any) => {
                        const records = get(res, "list");
                        records.map((item, index) => {
                            item.tableIndex = index + 1;
                        });
                        const total = get(res, "count");
                        console.log(1111, records);
                        resolve({records, total});
                    },
                ).catch(()=>{
                    reject({success: false});
                })
            } catch (e) {
                reject({success: false});
            }
        });
    };

    const extension = {
        request: {
            fetchList,
        },
        customRender: {
          enableRender(_, record: Record<string, any>) {
            const enabled = record?.enabled;
            return (
              <STags itemKey='' label={enabled ? '启用' : '禁用'} fontColor={enabled ? '#00A865' : '#EB3723'} bgColor={enabled ? '#D7F7EA' : '#FFEAE8'} />
            )
          },
        },
    };
    const rowClassName = (obj) => {
        const shopIds = obj?.shopIds || [];
        if(!shopIds.includes("0")&&!shopIds.includes(record?.companyId)&&!shopIds.includes(record?.searchOrgId)){
            return 'rowBgColor';
        }
        return '';
    };
    return (
        <SDrawerOrModal
            mode={'modal'}
            title={"SKU详情"}
            open={props?.open}
            // open={true}
            okText="保存"
            width={1000}
            onCancel={onClose}
            onClose={onClose}
            destroyOnClose={true}
            isHideCancelBtn={true}
            isHidenOkBtn={true}
        >
            <div className={"SDrawerOrModalBox"}>
                <div className={'modalTopBox'}>
                    <SAlert type="info">
                        <span className={'rowBgColor'}>红色字体行</span>表示该产品SKU数据异常：打包有配置查询门店可用，但产品SKU在供应链侧该门店可能已经缺断货或下架，需要联系总部打包人员处理
                    </SAlert>
                </div>
                <SLowcodeList
                    config={{...config}}
                    searchMode={"group"}
                    ref={listRef}
                    {...extension}
                    scroll={{y: 350}}
                    rowClassName={rowClassName}
                />
            </div>
        </SDrawerOrModal>
    );
};

export default SKUDetails;
